export default {
  provinceServiceDetails: (state, getters, rootState) => {
    const province = rootState.AppActiveUser.province
    return state.placeSubjectServiceDetail[province]
  }
}
